<template>
  <el-dialog
    :visible.sync="openDialog"
    lock-scroll
    :width="widthDialog"
    :close-on-click-modal="false"
    :close-on-press-escape="true"
    :show-close="false"
    :modal-append-to-body="
      modalAppendToBody == null ? false : modalAppendToBody
    "
    :append-to-body="appendToBody"
    :custom-class="classDialog"
    :top="offsetTop"
    :center="center"
    @closed="$emit('closed')"
  >
    <div slot="title">
      <i
        v-if="!!showCloseBtn"
        class="close-dialog clickable fal fa-times"
        @click="$emit('closeDialog')"
        @mousedown.prevent
      ></i>
      <slot name="header"></slot>
    </div>
    <div
      class="dialog-body"
      id="dialog-body-custom"
      v-on:scroll.passive="myFunction"
    >
      <VuePerfectScrollbar v-if="!disableScroll" class="pScrollDialog">
        <slot name="body"></slot>
      </VuePerfectScrollbar>
      <div v-else class="pScrollDialog" style="overflow-x: hidden">
        <slot name="body"></slot>
      </div>
    </div>
    <div slot="footer" class="dialog-footer" v-if="footerVisible">
      <slot name="footer"></slot>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "custom-dialog",
  components: {
    VuePerfectScrollbar: () => import("vue-perfect-scrollbar"),
  },
  props: {
    disableScroll: Boolean,
    openDialog: Boolean,
    widthDialog: String,
    classDialog: String,
    offsetTop: [Number, String],
    appendToBody: {
      type: Boolean,
      default: true,
    },
    center: Boolean,
    modalAppendToBody: {
      type: Boolean,
      default: true,
    },
    closeOnClickModal: Boolean,
    closeOnPressEscape: Boolean,
    showCloseBtn: {
      type: Boolean,
      default: true,
    },
    footerVisible: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    myFunction(e) {
      this.$emit("scrollBody", { scrollTop: e.target.scrollTop });
    },
  },
};
</script>

<style scoped>
.close-dialog {
  width: 30px;
  height: 30px;
  line-height: 27px;
  text-align: center;
  position: absolute;
  top: -14px;
  right: -14px;
  background: var(--color-dark);
  color: white;
  border-radius: 50%;
  border: 2px solid white;
  box-shadow: 0 6px 12px 0 rgba(0, 0, 0, 0.5);
  z-index: 4;
}

.pScrollDialog {
  max-width: 100%;
  width: 100%;
  max-height: calc(100% - 160px);
  height: auto;
  padding: 0 32px 5px;
}

@-moz-document url-prefix() {
  .pScrollDialog {
    max-height: calc(100vh - 160px) !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/common/custom-dialog.vue